//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { request } from '@/tools/index.js'
export default {
  name: 'BottomNavigation',
  props: {},
  data() {
    return {
      navigationList: [
        {
          name: '我的答题',
          icon: 'icon-answer',
          class: 'navigation-icon',
          handler: this.answer,
        },
        {
          name: '',
          icon: 'icon-add-circle',
          class: 'navigation-icon item-top',
          handler: this.add,
        },
        {
          name: '我的问卷',
          icon: 'icon-questionnaire',
          class: 'navigation-icon',
          handler: this.myQuestionnaire,
        },
      ],
    }
  },
  watch: {},
  computed: {},
  methods: {
    answer() {
      this.$router.push('/home')
      this.$emit('answer')
    },
    myQuestionnaire() {
      this.$router.push('/questionnaire')
      this.$emit('questionnaire')
    },
    add() {
      this.$router.push({
        name: 'create',
      })
      this.$emit('add')
    },
  },
}
